import { CharterStatus } from 'anchor-shared/lib/model/enum/charter-status';

export const sortCaseInsensitive = (s1, s2) => {
  if (s1 && s2) {
    return s1.toLowerCase().localeCompare(s2.toLowerCase());
  }
  return false;
};

export const sortByDate = (dateA, dateB) => {
  return new Date(dateA).getTime() - new Date(dateB).getTime();
};

export const sortByStatus = (statusA, statusB) => {
  const aIndex = STATUS_ORDER.findIndex((x) => x === statusA);
  const bIndex = STATUS_ORDER.findIndex((x) => x === statusB);
  return bIndex - aIndex;
};

const STATUS_ORDER: CharterStatus[] = [
  CharterStatus.needsApproval,
  CharterStatus.approvedPending,
  CharterStatus.pendingOffers,
  CharterStatus.booked,
  CharterStatus.completed,
  CharterStatus.cancelled,
  CharterStatus.cancelledByAdmin,
  CharterStatus.cancelledByOwner,
  CharterStatus.cancelledByRenter,
];
